import React, { useState } from 'react';
import './About.css';
import video from '../../data/videos/video1.mp4';
import template from '../../data/img/forVideo.png';
import playBtn from '../../data/img/play-btn.png';
import t1 from '../../data/img/t1.png';
import side_show_effect from './../../pages/side_show_effect';


const About = () => {
    const [paly, setPlay] = useState(false)
    const startController = () => {
        const videoPlayer = document.getElementById('video-player');
        videoPlayer.play()
        setPlay(true);
    }
    side_show_effect('.blog-container', '.video-section', '.teams')

    return (
        <div className="about">
            <div className="container">
                <div className='blog-container'>
                    <div className="video-section">
                        <div className="video-container">
                            <video id='video-player' width="400" controls={paly}  poster={template}>
                                <source src={video} type="video/mp4"/>
                            </video>
                            {
                                !paly && <button className="play-btn" onClick={startController}>
                                <img src={playBtn} alt="" />
                                </button>
                            }
                        </div>
                    </div>
                    <div className="teams">
                        <h1>who we are ?</h1>
                        <p>3plDashboard gives you complete control over your branding and user experience of your 3PL customers.3plDashboard gives you complete control over your branding and user experience of your 3PL customers.</p>
                        <div className="all-video">
                        <div className="all-video-container fist-video">
                            <video id='video-player' width="400" controls={paly}  poster={t1}>
                                <source src={video} type="video/mp4"/>
                            </video>
                            {
                                !paly && <button className="play-btn" onClick={startController}>
                                <img src={playBtn} alt="" />
                                </button>
                            }
                        </div>
                        <div className="all-video-container">
                            <video id='video-player' width="400" controls={paly}  poster={t1}>
                                <source src={video} type="video/mp4"/>
                            </video>
                            {
                                !paly && <button className="play-btn" onClick={startController}>
                                <img src={playBtn} alt="" />
                                </button>
                            }
                        </div>
                        
                        
                    </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

export default About;